import axios from "axios";
import { API_URL } from "../config/env";

class StakeService {
  static create_stake = (token, data) => {
    return axios.post(`${API_URL}/stakes`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  static complete_stake = (token, data) => {
    return axios.post(`${API_URL}/stakes/complete`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
  }
}

export default StakeService;
